import React from "react";
import { useBuilderFeeApproval } from "../hooks/useBuilderFeeApproval";
import { useWallet } from "../hooks/useWallet";

export function BuilderFeeApprovalModal({
  isOpen,
  onClose,
  onApproved,
  portfolioId,
  portfolio,
  config,
}) {
  const { loading, error, approve } = useBuilderFeeApproval();
  const { signer, network } = useWallet();
  const builderAddress = config?.builderAddress || "0xDdf3A93522D503a43f802BeB4882BfF18D940a20";
  const maxFeeRate = config?.builderFeeRate || "0.0100%";
  const hyperliquidNetwork = portfolio?.is_testnet ? "Testnet" : "Mainnet";

  if (!isOpen || portfolio?.builder_fee_approved === true) return null;

  const handleApprove = async () => {
    const success = await approve(
      signer,
      network,
      builderAddress,
      maxFeeRate,
      hyperliquidNetwork,
      portfolioId
    );
    if (success) {
      onApproved();
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-gray-900 rounded-lg p-6 max-w-md w-full mx-4">
        <h2 className="text-xl font-bold text-white mb-4">
          Authorize Trading Fees
        </h2>

        <p className="text-gray-300 mb-4">
          To trade through Katbot, you need to authorize a small builder fee.
          This is a one-time approval signed with your wallet.
        </p>

        <div className="bg-gray-800 rounded p-4 mb-4 space-y-2">
          <div className="flex justify-between text-sm">
            <span className="text-gray-400">Max Fee Rate</span>
            <span className="text-white">{maxFeeRate}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-gray-400">Builder</span>
            <span className="text-white font-mono text-xs">
              {builderAddress}
            </span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-gray-400">Expires</span>
            <span className="text-green-400">Never</span>
          </div>
        </div>

        <p className="text-gray-500 text-xs mb-4">
          This does not grant access to your funds. It only authorizes Katbot
          to include a fee on trades you execute through the platform.
          You can revoke this at any time on Hyperliquid.
        </p>

        {error && (
          <div className="bg-red-900/30 border border-red-500 rounded p-3 mb-4">
            <p className="text-red-400 text-sm">{error}</p>
          </div>
        )}

        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 border border-gray-600 rounded
                       text-gray-300 hover:bg-gray-800"
          >
            Cancel
          </button>
          <button
            onClick={handleApprove}
            disabled={loading}
            className="flex-1 px-4 py-2 bg-blue-600 rounded text-white
                       hover:bg-blue-700 disabled:opacity-50"
          >
            {loading ? "Signing..." : "Approve with MetaMask"}
          </button>
        </div>
      </div>
    </div>
  );
}
